<template>
  <div class="search">
    <el-input @keydown.enter="$emit('select')" placeholder="请输入关键字搜索" v-model="titleValue" style="width: 400px">
      <!-- <i @click="$emit('select')" slot="suffix" class="el-input__icon el-icon-search"></i> -->
    </el-input>
    <el-button @click="$emit('select')">查询</el-button>
  </div>
</template>
<script>
export default {
  props: ["name"],
  data() {
    return {};
  },
  computed: {
    titleValue: {
      set(v) {
        this.$emit("update:name", v);
      },
      get() {
        return this.$props.name;
      },
    },
  },
};
</script>

<style scoped lang="less">
.search {
    margin-top: 20px;
    width: 1200px;
    height: 70px;
    background-color: rgba(247, 247, 247, 1);
    padding-left: 39px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: end;
  }
</style>